<!-- User Modal -->
<p-dialog [visible]="!showCredentialModal" [modal]="true" [closable]="false" [draggable]="false" [resizable]="false"
  styleClass="!rounded-3xl !overflow-hidden !shadow-2xl" [style]="{ width: '520px' }" appendTo="body">

  <ng-template pTemplate="header">
    <h2 class="text-lg font-bold text-slate-800">
      {{ (isEditMode ? 'settings_user_edit_title' : 'settings_user_new_title') | translate }}
    </h2>
  </ng-template>

  <form [formGroup]="userForm" (ngSubmit)="saveUser()" class="flex flex-col gap-5 py-2">

    <!-- Error banner -->
    <div *ngIf="showError" class="p-3 bg-red-50 text-red-600 rounded-xl text-sm font-semibold animate-shake">
      {{ 'settings_profile_error_required' | translate }}
    </div>

    <!-- Name -->
    <div class="flex flex-col gap-1.5">
      <label class="text-[9px] font-black uppercase tracking-widest text-slate-500">
        {{ 'user_name' | translate }} <span class="text-red-500">*</span>
      </label>
      <input type="text" pInputText formControlName="name"
        class="w-full !rounded-xl !py-3 bg-slate-50 !border-slate-200"
        [placeholder]="'settings_user_name_placeholder' | translate">
    </div>

    <!-- User Type (read-only; this modal only creates "Usuário" accounts — doctors are managed via Professionals) -->
    <div class="flex flex-col gap-1.5">
      <label class="text-[9px] font-black uppercase tracking-widest text-slate-500">
        {{ 'user_type' | translate }}
      </label>
      <input type="text" pInputText [value]="userTypeDisplay" disabled readonly
        class="w-full !rounded-xl !py-3 bg-slate-50 !border-slate-200 !text-slate-500 disabled:opacity-70 !cursor-not-allowed">
    </div>

    <!-- Email -->
    <div class="flex flex-col gap-1.5">
      <label class="text-[9px] font-black uppercase tracking-widest text-slate-500">
        {{ 'user_email' | translate }} <span class="text-red-500">*</span>
      </label>
      <input type="email" pInputText formControlName="email"
        class="w-full !rounded-xl !py-3 bg-slate-50 !border-slate-200 disabled:opacity-50"
        [placeholder]="'settings_user_email_placeholder' | translate">
    </div>

    <!-- Phone with country code -->
    <div class="flex flex-col gap-1.5">
      <label class="text-[9px] font-black uppercase tracking-widest text-slate-500">
        {{ 'user_phone' | translate }} <span class="text-red-500">*</span>
      </label>
      <app-phone-input formControlName="phone"></app-phone-input>
    </div>

    <!-- Access Profile -->
    <div class="flex flex-col gap-1.5">
      <label class="text-[9px] font-black uppercase tracking-widest text-slate-500">
        {{ 'user_profile' | translate }} <span class="text-red-500">*</span>
      </label>

      <!-- Mock dropdown shown when empty - bulletproof against click-through -->
      <div *ngIf="accessProfiles.length === 0" (click)="onProfileDropdownClick($event)"
        class="w-full !rounded-xl bg-slate-50 border border-slate-200 py-3 px-4 flex justify-between items-center cursor-pointer transition-colors hover:bg-slate-100">
        <span class="text-slate-500/60 text-sm font-medium">{{ 'select_option' | translate }}</span>
        <i class="pi pi-chevron-down text-slate-400 text-[10px]"></i>
      </div>

      <!-- Real p-select shown only when we have data -->
      <p-select *ngIf="accessProfiles.length > 0" [options]="accessProfiles" formControlName="profileId"
        optionLabel="name" optionValue="id" [placeholder]="'select_option' | translate" appendTo="body"
        styleClass="w-full !rounded-xl bg-slate-50 !border-slate-200">
      </p-select>
    </div>

  </form>

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-3 pt-2">
      <app-button [label]="'cancel' | translate" variant="secondary" (onClick)="close.emit()">
      </app-button>
      <app-button [label]="saving ? ('saving' | translate) : ('save' | translate)" variant="primary" [loading]="saving"
        (onClick)="saveUser()" styleClass="min-w-[100px]">
      </app-button>
    </div>
  </ng-template>
</p-dialog>

<!-- Temp password reveal — shown once, right after a successful invite -->
<app-credential-reveal-modal *ngIf="showCredentialModal" [visible]="showCredentialModal" [email]="createdEmail"
  [tempPassword]="createdTempPassword" (closed)="onCredentialModalClosed()">
</app-credential-reveal-modal>

<!-- No Profile Found Dialog -->
<p-dialog [(visible)]="showNoProfileDialog" [modal]="true" [closable]="false" [draggable]="false" [resizable]="false"
  styleClass="!rounded-2xl !overflow-hidden" [style]="{ width: '400px' }" appendTo="body">

  <ng-template pTemplate="header">
    <h3 class="text-base font-bold text-slate-800">{{ 'no_profile_found_title' | translate }}</h3>
  </ng-template>

  <p class="text-sm text-slate-500 py-2">{{ 'no_profile_found_desc' | translate }}</p>

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-3">
      <button (click)="dismissNoProfileDialog()"
        class="px-5 py-2.5 rounded-xl text-sm font-bold text-slate-600 hover:bg-slate-100 transition-colors">
        {{ 'cancel' | translate }}
      </button>
      <button (click)="goToProfiles()"
        class="px-5 py-2.5 rounded-xl text-sm font-bold text-primary hover:bg-primary/10 transition-colors">
        {{ 'yes' | translate }}
      </button>
    </div>
  </ng-template>
</p-dialog>